import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_logindialog');

register('wm-logindialog', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmLoginDialog #${counter}="wmLoginDialog" 
          ${getAttrMarkup(attrs)} eventsource.bind="Actions.loginAction" wm-navigable-element="true">`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};